<template>
    <div class="row">
        <div class="col-md-3">
            <div id="show_filters" class="mb-3"><span class="button button-red button-small" @click="showFilters = true"><i class="icon-line-filter"></i> {{ dataTexts.show_filters_button }}</span></div>
            <div id="filters" :class="{'show': showFilters}">
                <div id="hide_filters" class="text-right">
                    <span class="btn btn-link btn-lg text-dark font-weight-bold" @click="showFilters = false"><i class="icon-line-cross"></i></span>
                </div>
                <div>
                    <label for="category">{{ dataTexts.filter_category }}</label>
                    <div class="ml-2"
                        :value="category.id"
                        v-for="category in dataCategories"
                        :key="category.id">
                        <span v-if="!dataCategory.length && dataCategory.id == category.id"  class="font-weight-bold">{{ category.name }}</span>
                        <a v-else :href="category.url" class="text-dark text-underline">{{ category.name }}</a>
                    </div>
                </div>
                <div
                    class="button button-red button-border button-small px-3 py-1 my-2"
                    :class="{invisible: !showReset}"
                    @click="reset"
                >
                    <i class="icon-line-cross"></i> {{ dataTexts.filter_reset }}
                </div>
                <div class="from-group mb-3">
                    <label for="search">{{ dataTexts.filter_search }}</label>
                    <input
                        id="search"
                        v-model="params.search"
                        class="form-control form-control-sm"
                        @keyup.enter="changeFilters"
                        autocomplete="off"
                    />
                </div>
                <div class="from-group mb-3">
                    <label for="cross_ref">{{ dataTexts.filter_cross_reference }}</label>
                    <input
                        id="cross_ref"
                        v-model="params.cross_ref"
                        class="form-control form-control-sm"
                        @keyup.enter="changeFilters"
                        autocomplete="off"
                    />
                    <span class="small d-block">
                        {{ dataTexts.filter_cross_reference_hint }}
                    </span>
                </div>
                <div v-for="filter in dataFilters" :key="filter.id">
                    <div v-if="filter.type == 'numeric' || filter.options.length" class="toggle" :data-state="filter.type != 'numeric' && params[filter.slug].length ? 'open' : false">
                        <div class="toggle-header">
                            <div class="toggle-icon">
                                <i class="toggle-closed icon-line-chevron-right"></i>
                                <i class="toggle-open icon-line-chevron-down"></i>
                            </div>
                            <label class="toggle-title">
                                {{ filter.name }}
                            </label>
                        </div>
                        <div class="toggle-content">
                            <div v-if="filter.type == 'options'">
                                <label
                                    v-for="option in filter.options"
                                    :key="option.id"
                                    :for="option.name"
                                    class="text-capitalize font-weight-normal ml-2">
                                    <input type="checkbox"
                                        v-model="params[filter.slug]"
                                        :id="option.name"
                                        :value="option.id"
                                        @click="changeFilters"
                                        /> {{ option.name }}
                                </label>
                            </div>
                            <div v-else-if="filter.type == 'numeric'">
                                <vue-slider-component
                                    v-model="params[filter.slug]"
                                    :tooltip="'always'"
                                    :tooltip-placement="['bottom', 'bottom']"
                                    :min="filter.min"
                                    :max="filter.max"
                                    v-on:drag-end="changeFilters"
                                    :enable-cross="false"
                                    @click.native="changeFilters"
                                    class="mb-4 px-4"
                                ></vue-slider-component>
                            </div>
                        </div>
                    </div>
                </div>
                <div id="button_filter">
                    <div class="button button-border button-fill button-red bg-white button-small" @click="changeFilters(); showFilters = false"><span>{{ dataTexts.filter_button}}</span></div>
                </div>
            </div>
        </div>
        <div id="products-container" class="col-md">
            <div class="py-2"><label class="d-inline">{{ dataTexts.results }}:</label> <span class="font-weight-normal font-italic">{{ result.total }}</span></div>
                <div id="products" class="row">
                    <div class="col-md-6 col-lg-4 mb-4"
                        v-for="product in products"
                        :key="product.ref">
                        <div class="bg-white rounded-bottom shadow">
                            <a :href="product.url" target="_blank">
                                <img
                                    loading="lazy"
                                    width="500"
                                    height="500"
                                    class="border-bottom"
                                    :src="product.thumbnail"
                                    :alt="product.name"
                                    :title="product.name"
                                />
                            </a>
                            <div class="p-3 position-relative bg-light">
                                <h2 class="mb-2 h6">
                                    <a :href="product.url" target="_blank">{{ product.ref }}</a>
                                </h2>
                                <span
                                    id="add-to-wishlist"
                                    class="btn pl-0"
                                    @click="toggleWishlist(product.id)"
                                    data-placement="left"
                                    :data-toggle="dataIsMobile ? '' : 'tooltip'"
                                    data-trigger="hover"
                                    :data-original-title="
                                        product.in_wishlist
                                            ? dataTexts.remove_from_wishlist
                                            : dataTexts.add_to_wishlist
                                    "
                                    ><i
                                        :class="{
                                            'icon-line-bookmark':
                                                !product.in_wishlist,
                                            'icon-bookmark21': product.in_wishlist,
                                        }"
                                    ></i
                                ></span>
                                <div>
                                    <a
                                        :href="product.url" target="_blank"
                                        class="text-secondary font-weight-semibold"
                                        >{{ product.name }}</a
                                    >
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            <vue-infinite-loading
                :identifier="infiniteId"
                spinner="waveDots"
                @infinite="getResult">
                <div slot="no-more">{{dataTexts.loading_no_more_products}}</div>
                <div slot="no-results">{{ dataTexts.loading_no_products_found }}</div>
            </vue-infinite-loading>
        </div>
    </div>
</template>

<script>
import VueSlider from "vue-slider-component";
import InfiniteLoading from "vue-infinite-loading";
export default {
    components: {
        "vue-slider-component": VueSlider,
        "vue-infinite-loading": InfiniteLoading
    },
    props: ["dataTexts", 'dataParams', 'dataCategory', 'dataCategories', 'dataFilters', 'dataIsMobile'],
    data() {
        return {
            products: [],
            result: {},
            params: this.getInitParams(),
            page: 1,
            showFilters: false,
            infiniteId: +new Date(),
        };
    },
    computed: {
        showReset() {
            if (this.params.search || this.params.cross_ref) {
                return true;
            }
            for (var i = 0; i < this.dataFilters.length; i++) {
                if (this.params[this.dataFilters[i].slug].length
                    && this.dataFilters[i].slug != 'category'
                    && this.dataFilters[i].type != 'numeric'
                ) { return true; }

                if (this.dataFilters[i].type == 'numeric'
                    && (this.dataFilters[i].min != this.params[this.dataFilters[i].slug][0]
                        || this.dataFilters[i].max != this.params[this.dataFilters[i].slug][1])
                ) { return true; }
            }
        },
    },
    mounted() {
        if (!this.dataIsMobile) {
            window.addEventListener('scroll', this.handleScroll);
        }
    },
    methods: {
        handleScroll() {
            if ($(window).scrollTop() >= $('#products').offset().top - 70) {
                $('#filters').addClass('fixed')
            } else {
                $('#filters').removeClass('fixed')
            }
            this.adaptFiltersBlockHeight()
        },
        adaptFiltersBlockHeight() {
            if (!this.dataIsMobile) {
                if (($(window).scrollTop()+$(window).height()) >= $('#footer').offset().top) {
                    $('#filters').css('max-height', 'calc(100vh - ' + ($(window).scrollTop() + $(window).height() - $('#footer').offset().top + $('#header-wrap').height())+'px)')
                } else {
                    $('#filters').css('max-height', 'calc(100vh - '+ $('#header-wrap').height() +'px)')
                }
            }
        },
        getInitParams() {
            return {
                category: this.dataCategory ? this.dataCategory.id : null,
                ...this.dataParams,
            };
        },
        reset() {
            this.params.search = this.params.cross_ref = null
            for (var i = 0; i < this.dataFilters.length; i++) {
                if (this.dataFilters[i].type == 'text') {
                    this.params[this.dataFilters[i].slug] = ''
                } else if (this.dataFilters[i].type == 'numeric') {
                    this.params[this.dataFilters[i].slug] = [this.dataFilters[i].min, this.dataFilters[i].max]
                } else {
                    this.params[this.dataFilters[i].slug] = []
                }
            }
            this.changeFilters()
            this.showFilters = false
        },
        getResult($state) {
            axios
            .get("/ajax/products", {
                params: {
                    page: this.page,
                    ...this.params,
                },
            })
            .then((response) => {
                this.result = response.data
                if (response.data.data.length) {
                    this.page += 1;
                    this.products.push(...response.data.data);
                    $state.loaded();
                } else {
                    $state.complete();
                }
            }).then(() => {
                if (!this.dataIsMobile) {
                    $('body').tooltip({selector: '[data-toggle="tooltip"]'});
                }
                this.adaptFiltersBlockHeight()
            })
        },
        changeFilters() {
            this.page = 1;
            this.products = [];
            this.infiniteId += 1;
            $('html').animate({ scrollTop: $('#products').offset().top - 170 }, 100)
        },
        toggleWishlist(product_id) {
            axios
                .get("/ajax/wishlist", {
                    params: {
                        product_id: product_id,
                    },
                })
                .then((response) => {
                    this.products.map((prod) => {
                        if (response.data.find((id) => prod.id == id)) {
                            prod.in_wishlist = true
                        } else {
                            prod.in_wishlist = false
                        }
                    })
                    this.$root.$emit("updateWishlist", response.data.length);
                });
        },
    },
};
</script>
